(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tb-announcement-bar')) {
  customElements.define('tb-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      this.messages = [...this.querySelectorAll('[data-message]')];
      this.track = this.querySelector('[data-messages]');
      this.toggle = this.querySelector('[data-toggle]');
      this.next = this.querySelector('[data-next]');
      this.counter = this.querySelector('[data-count]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.hovered = false;
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || this.hasAttribute('data-design-mode');
      this.delay = Math.max(5000, Number(this.dataset.interval) || 8000);
      if (this.messages.length < 2) return;
      this.toggle.hidden = false;
      this.next.hidden = false;
      this.toggle.addEventListener('click', () => this.setPaused(!this.paused), options);
      this.next.addEventListener('click', () => { this.setPaused(true); this.showNext(); }, options);
      this.addEventListener('focusin', () => this.setPaused(true), options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.setPaused(true); }, options);
      this.setPaused(this.paused);
    }
    setPaused(paused) {
      this.paused = paused;
      this.toggle.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.querySelector('[data-pause-icon]').hidden = paused;
      this.toggle.querySelector('[data-play-icon]').hidden = !paused;
      this.track.setAttribute('aria-live', paused ? 'polite' : 'off');
      this.schedule();
    }
    showNext() {
      this.index = (this.index + 1) % this.messages.length;
      this.messages.forEach((message, index) => {
        const active = index === this.index;
        message.setAttribute('aria-hidden', String(!active));
        message.tabIndex = active ? 0 : -1;
      });
      this.counter.textContent = `${this.index + 1}/${this.messages.length}`;
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || document.hidden || !this.isConnected) return;
      this.timer = setTimeout(() => { this.showNext(); this.schedule(); }, this.delay);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.listeners?.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-article"]) return;
  try {
    
if(!customElements.get('tb-article-media')){customElements.define('tb-article-media',class extends HTMLElement{connectedCallback(){requestAnimationFrame(()=>{if(this.dataset.ready)return;this.dataset.ready='true';const dialog=this.querySelector('.tbr-image-dialog');if(!dialog)return;this.querySelectorAll('.tbr-article-body > p img,.tbr-article-body > figure img').forEach(img=>{if(img.closest('a,button')||Number(img.getAttribute('width'))>0&&Number(img.getAttribute('width'))<80)return;const button=document.createElement('button');button.type='button';button.className='tbr-inline-zoom tbr-zoom-trigger';button.dataset.tbrEnlarge='';button.setAttribute('aria-label',this.dataset.enlargeLabel);img.before(button);button.append(img);img.loading='lazy';});this.addEventListener('click',event=>{const trigger=event.target.closest('[data-tbr-enlarge]');if(trigger){const source=trigger.querySelector('img');const image=dialog.querySelector('img');image.src=trigger.dataset.fullImage||source.currentSrc||source.src;image.alt=source.alt;dialog.querySelector('.tbr-image-caption').textContent=source.alt;this.lastTrigger=trigger;dialog.showModal();}if(event.target.closest('[data-tbr-close]')||event.target===dialog)dialog.close();});dialog.addEventListener('close',()=>this.lastTrigger?.focus());});}});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-box-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-box-selector')) {
    class TBBoxSelector extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.choices = Array.from(this.querySelectorAll('[data-box-choice]'));
        this.panels = Array.from(this.querySelectorAll('[data-box-panel]'));
        const activeBlock = this.panels.find(panel => !panel.hidden)?.dataset.boxPanel || this.dataset.defaultBlock;
        this.choices.forEach(choice => {
          choice.setAttribute('role', 'button');
          choice.setAttribute('aria-pressed', String(choice.dataset.boxChoice === activeBlock));
        });
        this.querySelectorAll('[data-box-image-toggle]').forEach(button => { button.hidden = false; });
        this.querySelectorAll('[data-box-media-toggle]').forEach(button => {
          const panel = button.closest('[data-box-panel]');
          const inside = panel.querySelector('[data-box-inside]');
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.disabled = false;
          inside.hidden = false;
          inside.setAttribute('aria-hidden', String(!expanded));
          panel.querySelector('[data-box-cover]').setAttribute('aria-hidden', String(expanded));
          button.addEventListener('pointerenter', event => {
            if (event.pointerType === 'mouse') this.setImage(panel, true);
          }, options);
          button.addEventListener('pointerleave', event => {
            if (event.pointerType === 'mouse') this.setImage(panel, panel.dataset.boxImagePinned === 'true');
          }, options);
        });
        this.panels.find(panel => !panel.hidden)?.querySelector('[data-box-inside] img')?.setAttribute('loading', 'eager');
        this.addEventListener('click', event => {
          const choice = event.target.closest('[data-box-choice]');
          if (choice && this.contains(choice) && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey) {
            event.preventDefault();
            this.selectBox(choice.dataset.boxChoice);
          }
          const toggle = event.target.closest('[data-box-image-toggle], [data-box-media-toggle]');
          if (toggle && this.contains(toggle)) this.toggleImage(toggle);
        }, options);
        this.addEventListener('keydown', event => {
          const choice = event.target.closest('[data-box-choice]');
          if (choice && event.key === ' ') {
            event.preventDefault();
            this.selectBox(choice.dataset.boxChoice);
          }
        }, options);
        const warmImage = event => {
          const choice = event.target.closest('[data-box-choice]');
          if (!choice) return;
          const panel = this.panels.find(item => item.dataset.boxPanel === choice.dataset.boxChoice);
          panel?.querySelector('[data-box-cover] img')?.setAttribute('loading', 'eager');
        };
        this.addEventListener('pointerover', warmImage, options);
        this.addEventListener('focusin', warmImage, options);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target) && this.choices.some(choice => choice.dataset.boxChoice === event.detail.blockId)) this.selectBox(event.detail.blockId, false);
        }, options);
      }
      disconnectedCallback() {
        this.controller?.abort();
      }
      selectBox(blockId, announce = true) {
        const selected = this.panels.find(panel => panel.dataset.boxPanel === blockId);
        if (!selected) return;
        this.panels.forEach(panel => {
          if (panel !== selected) this.setImage(panel, panel.dataset.boxImagePinned === 'true');
          panel.hidden = panel !== selected;
        });
        selected.querySelector('[data-box-inside] img')?.setAttribute('loading', 'eager');
        this.choices.forEach(choice => {
          const active = choice.dataset.boxChoice === blockId;
          choice.classList.toggle('is-selected', active);
          choice.setAttribute('aria-pressed', String(active));
          if (active && announce) this.querySelector('[data-box-status]').textContent = choice.dataset.boxName;
        });
      }
      toggleImage(button) {
        const panel = button.closest('[data-box-panel]');
        const expanded = panel.dataset.boxImagePinned !== 'true';
        panel.dataset.boxImagePinned = String(expanded);
        this.setImage(panel, expanded);
      }
      setImage(panel, expanded) {
        const inside = panel.querySelector('[data-box-inside]');
        if (!inside) return;
        panel.boxImageRequest = (panel.boxImageRequest || 0) + 1;
        const request = panel.boxImageRequest;
        const apply = () => {
          if (panel.boxImageRequest !== request) return;
          const media = panel.querySelector('[data-box-media-toggle]');
          const text = panel.querySelector('[data-box-image-toggle]');
          const cover = panel.querySelector('[data-box-cover]');
          if (media) {
            cover.hidden = false;
            inside.hidden = false;
            cover.setAttribute('aria-hidden', String(expanded));
            inside.setAttribute('aria-hidden', String(!expanded));
            media.classList.toggle('is-showing-inside', expanded);
            media.setAttribute('aria-expanded', String(expanded));
            const label = text?.querySelector(expanded ? '[data-box-toggle-close]' : '[data-box-toggle-open]')?.textContent;
            if (label) media.setAttribute('aria-label', label);
          } else {
            cover.hidden = expanded;
            inside.hidden = !expanded;
          }
          const note = panel.querySelector('[data-box-photo-note]');
          if (note) note.hidden = !expanded;
          if (text) {
            text.setAttribute('aria-expanded', String(expanded));
            text.querySelector('[data-box-toggle-open]').hidden = expanded;
            text.querySelector('[data-box-toggle-close]').hidden = !expanded;
          }
        };
        const image = inside.querySelector('img');
        if (expanded && image && !image.complete && typeof image.decode === 'function') {
          image.loading = 'eager';
          image.decode().then(apply).catch(() => {});
        } else {
          apply();
        }
      }
    }
    customElements.define('tb-box-selector', TBBoxSelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-brand-videos"] && !Shopify.designMode) return;
  try {
    
  // Capture also covers native controls and videos replaced by the theme editor.
  document.addEventListener('play', (event) => {
    const activeVideo = event.target;
    if (!(activeVideo instanceof HTMLVideoElement) ||
        !activeVideo.hasAttribute('data-tb-exclusive-video') || activeVideo.paused) return;

    for (const video of document.querySelectorAll('video[data-tb-exclusive-video]')) {
      if (video !== activeVideo && !video.paused) video.pause();
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tb-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tb-hero-carousel')) {
    customElements.define('tb-hero-carousel', class extends HTMLElement {
      async connectedCallback() {
        this.abort = new AbortController();
        const { signal } = this.abort;
        await customElements.whenDefined('slideshow-component');
        if (signal.aborted || !this.isConnected) return;
        const slider = this.querySelector('slideshow-component');
        if (!slider) return;
        const slides = Array.from(this.querySelectorAll('.tb-hero-slide'));
        const sync = () => slides.forEach(slide => { slide.inert = slide.getAttribute('aria-hidden') === 'true'; });
        sync();
        this.observer = new MutationObserver(sync);
        this.observer.observe(slider, { subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
        const motion = matchMedia('(prefers-reduced-motion: reduce)');
        const pause = () => slider.pause();
        motion.addEventListener('change', event => { if (event.matches) pause(); }, { signal });
        this.addEventListener('focusin', pause, { signal });
        if (slider.autoplay && slides.length > 1 && !motion.matches && !this.matches(':focus-within')) slider.play();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
